import axios from 'axios'

const isEnvDevelopment = process.env.NODE_ENV === 'development'
axios.defaults.withCredentials = true
axios.defaults.baseURL = isEnvDevelopment ? '/' : 'https://api-kos.wps.cn'
const service = axios.create({
  timeout: 5 * 60 * 1000
})

service.interceptors.request.use(async (config) => {
  return config
}, (error) => {
  return Promise.reject(error)
})

service.interceptors.response.use(async (result) => {
  const { data } = result || {}
  return data
}, (error) => {
  const status = error?.response?.status
  if (status) {
    return Promise.reject(error?.response?.data)
  }
  return Promise.reject(error)
})

export default service
